export default {
    name: 'careerPreferences',
    dependencies: ['radio'],
    callable(radio) {
        function renderPreferencePrompt(orgName) {
            // triggers the reactEntryPoint.js to render
            // a react app that is the career-preferences popover
            const CHANNEL = 'careerPreferences:show';
            radio(CHANNEL).broadcast(orgName);
        }

        return { renderPreferencePrompt };
    },
};



// WEBPACK FOOTER //
// ./services/careerPreferences.js